import TeamsMain from './views/TeamsMain.vue';
import TeamsIndex from './views/TeamsIndex.vue';
import TeamShow from './views/TeamShow.vue';
import FirmAdvisors from './views/FirmAdvisors.vue';

const routes = [
  {
    name: 'teams',
    path: '/advisor/teams',
    component: TeamsMain,
    children: [
      {
        name: 'teams-index',
        path: '',
        component: TeamsIndex,
      },
      {
        name: 'firm-advisors',
        path: 'firm-advisors',
        component: FirmAdvisors,
      },
      {
        name: 'team-show',
        // full path: /advisor/teams/:teamExternalId
        path: ':teamExternalId',
        component: TeamShow,
        props: route => ({ teamExternalId: route.params.teamExternalId }),
      },
    ],
  },
];

export default routes;
